import { create } from 'zustand';

export interface CursorStore {
  customCursorActive?: boolean;
  activeToolSubMode: 'pipette' | null;
  position?: { x: number; y: number };
  visible: boolean;
}

export const useCursorStore = create<CursorStore>()(() => ({
  customCursorActive: false,
  activeToolSubMode: null,
  position: undefined,
  visible: false,
}));

export const updateCursorStore = (state: Partial<CursorStore>) => {
  useCursorStore.setState(state);
  return useCursorStore.getState();
};
